import { ExploreSlider } from "../../../components";

//slider images
import festival3 from "../../../assets/explore-slider/festival3.webp";
import festival4 from "../../../assets/explore-slider/festival4.webp";
import festival5 from "../../../assets/explore-slider/festival5.webp";
import festival6 from "../../../assets/explore-slider/festival6.webp";

export const Festivals = () => {
  const sliderImages = [festival3, festival4, festival5, festival6];
  console.log(sliderImages);
  return (
    <div>
      <section>
        <ExploreSlider images={sliderImages} style={{ width: "100%" }} />
      </section>
    </div>
  );
};
